import { useFormContext } from 'react-hook-form';
import { useUserPaymentTypeIdByCoinId } from '../useUserPaymentTypeIdByCoinId';
import {
  CreateUserPaymentDetailsInputDto,
  UpdateUserPaymentDetailsInputDto,
} from '../../../dto';
import { Nullable } from '../../../interfaces';

/**
 * Custom hook to get the coalesced user payment type ID.
 * This hook combines the type ID from the form context and the user payment type ID by coin ID.
 *
 * @returns {string} The coalesced user payment type ID.
 *
 * @example
 * // Usage example:
 * const userPaymentTypeId = useCoallescedUserPaymentTypeId();
 */
export function useCoallescedUserPaymentTypeId(): string {
  // Get the watch function from the form context
  const { watch } = useFormContext<
    CreateUserPaymentDetailsInputDto & UpdateUserPaymentDetailsInputDto
  >();

  // Watch the 'typeId' field from the form context
  const formTypeId: string = watch('typeId');

  // Get the user payment type ID by coin ID using the custom hook
  const userPaymentTypeIdByCoinId: Nullable<string> =
    useUserPaymentTypeIdByCoinId() as string;

  // Return the form type ID if it exists, otherwise return the user payment type ID by coin ID
  return formTypeId ?? userPaymentTypeIdByCoinId;
}
